import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output } from "@angular/core";

@Component({
  selector: "icn-time-picker",
  templateUrl: "./time-picker.component.html",
  styleUrls: ["./time-picker.component.scss"],
})
export class TimePickerComponent implements OnInit, OnChanges {
  @Input()
  overrideStyle: { [key: string]: string } = null;
  @Input() timeInMinutes: number;
  @Output() timeInMinutesChange = new EventEmitter<number>();

  timeValue: string;

  ngOnInit(): void {
    this.updateTimeValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['timeInMinutes'] && !changes['timeInMinutes'].firstChange) {
      this.updateTimeValue();
    }
  }

  private updateTimeValue() {
    const hours = Math.floor(this.timeInMinutes / 60);
    const minutes = this.timeInMinutes % 60;

    this.timeValue =
      `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  onBlur(): void {
    const [h, m] = this.timeValue.split(":").map(x => parseInt(x, 10));
    this.timeInMinutes = h * 60 + m;
    this.timeInMinutesChange.emit(this.timeInMinutes);
  }
}
